import * as React from "react";
import * as moment from "moment";
import { Button, DropdownItemProps, ButtonGroup } from "semantic-ui-react";
import SemanticDatepicker from "react-semantic-ui-datepickers";
import { SemanticDatepickerProps } from "react-semantic-ui-datepickers/dist/types";
import { Moment } from "moment";

import { Input } from "@neworbit/simpleui-input";

import { CalendarView } from ".";

interface Props {
    view: CalendarView;
    currentDate: Moment;
    date: Moment;
    onDateChange: (date: Moment) => void;
    disablePastDates?: boolean;
    showDateRange?: boolean;
    dateOptions?: DropdownItemProps[];
}

export const DateSelector: React.FunctionComponent<Props> = (props) => {

    const date = props.date && props.date.toDate();

    const onDateChange = (event: React.SyntheticEvent<Element, Event>, data: SemanticDatepickerProps) => {
        const newDate = data.value as Date;
        const newDateAsMoment = newDate && moment(newDate.toUTCString()).utc(true);
        if (newDateAsMoment && newDateAsMoment.isValid() && props.date.format("DD/MM/YYYY") !== newDateAsMoment.format("DD/MM/YYYY")) {
            props.onDateChange(newDateAsMoment);
        }
    };

    return (
        <>
            {!props.showDateRange &&
                <div className="datepicker-container">
                    <div className="day-name">
                        {props.date.format("dddd")}
                    </div>
                    <SemanticDatepicker
                        value={date}
                        onChange={onDateChange}
                        clearable={false}
                        format={"DD/MM/YYYY"}
                        className="calendar-datepicker"
                        iconPosition="left"
                    />
                </div>
            }
            {props.showDateRange &&
                <Input.Dropdown
                    options={props.dateOptions}
                    onChange={(value) => value && props.date !== moment.utc(value) && props.onDateChange(moment.utc(value))}
                    value={props.date.format((moment as any).HTML5_FMT.DATE)}
                />
            }
            <ButtonGroup>
                <Button basic
                    icon="chevron left"
                    disabled={props.disablePastDates && props.currentDate.utc().startOf("day").add(1, "day").diff(props.date, "days") >= 0}
                    // eslint-disable-next-line react/jsx-no-bind
                    onClick={() => props.onDateChange(props.date.clone().subtract(1, props.view).startOf(props.view))}
                />
                <Button basic
                    icon="chevron right"
                    // eslint-disable-next-line react/jsx-no-bind
                    onClick={() => props.onDateChange(props.date.clone().add(1, props.view).startOf(props.view))}
                />
            </ButtonGroup>
            <Button secondary
                // eslint-disable-next-line react/jsx-no-bind
                onClick={() => props.onDateChange(props.currentDate.utc().startOf("day"))}
            >
                Today
            </Button>
        </>
    );
};
